import { FrxBaseBean } from './frxbasebean';
export class Lawyer extends FrxBaseBean {
	names: string;
	active: boolean;
	authority: string;
	email: string;
	phone: string;
	username: string;
	color: string;
}
